export const COMPANYCORRESPONDENCELIST_SEARCH = 'COMPANYCORRESPONDENCELIST_SEARCH';
export const COMPANYCORRESPONDENCELIST_PAGE = 'COMPANYCORRESPONDENCELIST_PAGE';
export const COMPANYCORRESPONDENCELIST_YEAR = 'COMPANYCORRESPONDENCELIST_YEAR';
